import { Pipe, PipeTransform } from '@angular/core';
import { NotificationBallSeverity } from '../../core/components/layout/topbar/shared/notification-severity-ball/notification-severity-ball.component';
import { AlarmLevel } from '../../pages/notifications/enums/alarm-level.enum';

@Pipe({
  name: 'alarmLevelToNotificationBallSeverity',
  standalone: true,
})
export class AlarmLevelToNotificationBallSeverityPipe implements PipeTransform {
  transform(alarmLevel?: AlarmLevel): NotificationBallSeverity {
    switch (alarmLevel) {
      case AlarmLevel.LOW:
        return 'success';
      case AlarmLevel.MID:
        return 'warning';
      case AlarmLevel.HIGH:
        return 'danger';
      default:
        return 'info';
    }
  }
}
